<template>
    <v-app>
        <!-- header app bar -->
        <bar-app v-if="!noTopBars"></bar-app>
        <!-- App drawers -->
        <!-- user setting drawer -->
        <drawer-account v-if="$store.state.account.isLogedIn && !isDesktop"></drawer-account>
        <!-- Main content -->
        <v-content :class="[primaryMobileBackground ? 'primary' : 'secondary']">
            <!-- Router View -->
            <v-fade-transition hide-on-leave>
                 <router-view></router-view>
            </v-fade-transition>
        </v-content>
        <!-- Footer main -->
        <router-view name="footer-main" v-if="isDesktop && !noFooter"></router-view>
        <!-- Bottom navigation for mobiles -->
        <v-expand-transition>
            <bar-bottom-mobile v-if="!noBottomBars"></bar-bottom-mobile>
        </v-expand-transition>
        <!-- Error Notification -->
        <error-snackbar></error-snackbar>
        <!-- Common Notifications -->
        <notification-snackbar></notification-snackbar>
    </v-app>
</template>
<script>
import * as firebase from "firebase/app"
import utilities from "@/base/utilities"
import { version } from "../package.json"
export default {
    name: 'App',

    metaInfo: {
        changed(metaInfo) {
            firebase.analytics().setCurrentScreen(metaInfo.title)
            firebase.analytics().logEvent("page_view")
            firebase.analytics().logEvent("screen_view", {
                app_name: utilities.isPWA() ? "pwa" : "web",
                screen_name: metaInfo.title,
                app_version: version
            })
        },

        title: 'Arclif',
        titleTemplate: '%s | Arclif'
    },

    computed: {
        userSettingsDrawer() {
            return this.$store.getters.getUserSettingsDrawer
        },

        // Avoid top bars in following routes
        noTopBars() {
            return this.$route.matched.some(record => record.meta.noTopbars)
        },

        // Avoid bottom bars in following routes and desktop
        noBottomBars() {
            return this.isDesktop || this.$route.matched.some(record => record.meta.noBottombarsMobile)
        },

        // Avoid footer for certain routes
        noFooter() {
            return this.$route.matched.some(record => record.meta.noFooters)
        },

        // Select primary background colors for following routes in mobile
        primaryMobileBackground() {
            return !this.isDesktop && this.$route.matched.some(record => record.meta.primaryOnMobile)
        }
    },

    watch: {
        '$vuetify.theme.dark'(val) {
            if(val) {
                document.querySelector('meta[name="theme-color"]').setAttribute('content',  '#000')
            } else {
                document.querySelector('meta[name="theme-color"]').setAttribute('content',  '#fff')
            }
        }
    }
};
</script>